import {computed, reactive, toRefs, ref, readonly} from 'vue'
import moment from 'moment'
import type {CompareType} from 'src/biz_spa/domains/analysis/types'

export const GaLikeDatePickTypes = ['beforePeriod', 'beforePeriodSameDayOfWeek', 'beforePeriodLastYear'] as const
export type GaLikeDatePickType = typeof GaLikeDatePickTypes[number]

export interface Period {
  startDate: Date,
  endDate: Date,
}

const useGaLikeDatePicker = (props: Period) => {
  const compareType = ref<CompareType>('average')
  const changeCompareType = (type: CompareType) => {
    compareType.value = type
  }
  const period = reactive({
    startDate: props.startDate,
    endDate: props.endDate
  })
  const type = ref<GaLikeDatePickType>(GaLikeDatePickTypes[0])
  const changeType = (value: GaLikeDatePickType) => {
    type.value = value
  }
  const changePeriod = (value: Period) => {
    const range = moment(value.endDate).diff(moment(value.startDate), 'day')
    if (range > 365) {
      alert('日付の範囲は365日以内にしてください')
      return false
    }
    period.startDate = value.startDate
    period.endDate = value.endDate
    return true
  }
  const comparedPeriod = computed<Period>(() => {
    switch (type.value) {
    // 前の期間と比較する
    case 'beforePeriod': {
      const range = moment(period.endDate).diff(period.startDate, 'day')
      return {
        startDate: moment(period.startDate).subtract(range, 'day').toDate(),
        endDate: moment(period.startDate).subtract(1, 'day').toDate()
      }
    }
    // 前の期間と同一曜日で比較する
    case 'beforePeriodSameDayOfWeek': {
      const range = moment(period.endDate).diff(period.startDate, 'day')
      const amount = Math.floor(range / 7) || 1
      return {
        startDate: moment(period.startDate).subtract(amount, 'week').toDate(),
        endDate: moment(period.endDate).subtract(amount, 'week').toDate()
      }
    }
    // 前年の同じ期間と比較する
    case 'beforePeriodLastYear':
      return {
        startDate: moment(period.startDate).subtract(1, 'year').toDate(),
        endDate: moment(period.endDate).subtract(1, 'year').toDate()
      }
    default:
      throw new Error('invalid type')
    }
  })

  return {
    // TODO: readonlyにしたい
    period: toRefs(period),
    changePeriod,
    type: readonly(type),
    changeType,
    compareType: readonly(compareType),
    changeCompareType,
    comparedPeriod: readonly(comparedPeriod),
  }
}

export { useGaLikeDatePicker }
